import React from 'react';

export const UndoBanner = ({ undoTimer, undoAction, undoCountdown, executeUndo, cancelUndo }) => {
  if (!undoTimer || !undoAction) return null;

  return (
    <div className="fixed top-0 left-0 right-0 animate-slide-in" style={{ zIndex: 10000 }}>
      <div className="bg-gradient-to-r from-orange-600 to-red-600 border-b-4 border-orange-400 px-4 py-3 flex items-center justify-between shadow-2xl">
        <div className="flex items-center gap-3">
          <div className="bg-black border-2 border-orange-300 px-3 py-1">
            <span className="text-orange-400 font-black text-2xl">{undoCountdown}</span>
          </div>
          <div>
            <p className="text-white font-black text-sm sm:text-base uppercase">BITCHED OUT?</p>
            <p className="text-orange-200 text-xs font-bold">Action will be final in {undoCountdown}s</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={executeUndo}
            className="bg-lime-500 hover:bg-lime-400 text-black px-4 py-2 font-black text-sm uppercase border-2 border-lime-400 transition-all"
          >
            ↺ UNDO
          </button>
          <button
            onClick={cancelUndo}
            className="bg-gray-800 hover:bg-gray-700 text-gray-300 px-4 py-2 font-black text-sm uppercase border-2 border-gray-700 transition-all"
          >
            ✓ KEEP IT
          </button>
        </div>
      </div>
    </div>
  );
};
